import {createSelector} from 'reselect';
import MessageType from '../../../../enums/MessageType';
import getNewpayScriptLoadFailure from './getNewpayScriptLoadFailure';
import getShouldDisableNewpay from './getShouldDisableNewpay';

export const getNewpayErrorMessage = createSelector(
  [getShouldDisableNewpay, getNewpayScriptLoadFailure],
  (shouldDisableNewpay, scriptLoadFailure) => {
    if (shouldDisableNewpay && scriptLoadFailure) {
      return {type: MessageType.ERROR, translationKey: 'newpay.failure'};
    }
    
    if (shouldDisableNewpay) {
      return {type: MessageType.ERROR, translationKey: 'newpay.unavailable'};
    }
  },
);

export default getNewpayErrorMessage;
